import { LayoutComponent } from "@jelly/lesson";
import config from "appConfig";
import variables from "../../../../../../../assets/styles/sass-resources.scss";

export const component: LayoutComponent = {
  variant: "layout",
  data: {
    type: "table",
    options: {
      cols: 5,
      rows: 2,
      rowsSize: [1, 3],
      colsSize: [1, 1.7, 1.2, 1.7, 1],
      colSpan: {
        "1:0": 5,
      },
      gap: "3%",
      components: [
        [
          null,
          {
            variant: "layout",
            data: {
              type: "table",
              options: {
                cols: 1,
                rows: 2,
                components: [
                  [
                    {
                      variant: "blockContainer",
                      data: {
                        block: {
                          type: "audioButton",
                          options: {
                            icon: "cis-volume-high",
                            theme: "secondary",
                            shape: "round",
                            url: `${config.ASSETS_URL}/05/10/principle/speech-100m3-1-0s.wav`,
                            size: "large",
                          },
                        },
                        styles: {
                          alignItems: "flex-end",
                        },
                      },
                    },
                  ],
                  [
                    {
                      variant: "blockContainer",
                      data: {
                        block: {
                          type: "text",
                          options: {
                            formatter: "html",
                            scrollbars: false,
                            data: `<small style="font-size: 14px">L<sub>p,Rev</sub> = 62 dB</b><br><span style="color:${variables["secondary"]}">L<sub>w</sub> = 68 dB</span>`,
                          },
                        },
                        styles: {
                          alignItems: "flex-start",
                          textAlign: "center",
                        },
                      },
                    },
                  ],
                ],
              },
            },
          },
          {
            variant: "layout",
            data: {
              type: "table",
              options: {
                cols: 1,
                rows: 2,
                components: [
                  [
                    {
                      variant: "blockContainer",
                      data: {
                        block: {
                          type: "audioButton",
                          options: {
                            icon: "cis-volume-high",
                            theme: "primary",
                            shape: "round",
                            url: `${config.ASSETS_URL}/05/10/principle/flute-100m3-1-0s.wav`,
                            size: "large",
                          },
                        },
                        styles: {
                          alignItems: "flex-end",
                        },
                      },
                    },
                  ],
                  [
                    {
                      variant: "blockContainer",
                      data: {
                        block: {
                          type: "text",
                          options: {
                            formatter: "html",
                            scrollbars: false,
                            data: `<small style="font-size: 14px;color:${variables["primary"]}">L<sub>p,Rev</sub> = 85 dB</b><br><span style="color:${variables["secondary"]}">L<sub>w</sub> = 91 dB</span>`,
                          },
                        },
                        styles: {
                          alignItems: "flex-start",
                          textAlign: "center",
                        },
                      },
                    },
                  ],
                ],
              },
            },
          },
          {
            variant: "layout",
            data: {
              type: "table",
              options: {
                cols: 1,
                rows: 2,
                components: [
                  [
                    {
                      variant: "blockContainer",
                      data: {
                        block: {
                          type: "audioButton",
                          options: {
                            icon: "cis-volume-high",
                            theme: "primary",
                            shape: "round",
                            url: `${config.ASSETS_URL}/05/10/principle/orchestra-100m3-1-0s.wav`,
                            size: "large",
                          },
                        },
                        styles: {
                          alignItems: "flex-end",
                        },
                      },
                    },
                  ],
                  [
                    {
                      variant: "blockContainer",
                      data: {
                        block: {
                          type: "text",
                          options: {
                            formatter: "html",
                            scrollbars: false,
                            data: `<small style="color:${variables["primary"]};font-size: 14px">L<sub>p,Rev</sub> = 104 dB</b><br><span style="color:${variables["secondary"]}">L<sub>w</sub> = 110 dB</span>`,
                          },
                        },
                        styles: {
                          alignItems: "flex-start",
                          textAlign: "center",
                        },
                      },
                    },
                  ],
                ],
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/05/10/principle/living-room.svg`,
                },
              },
            },
          },
        ],
      ],
    },
  },
};
